import { getAccessToken } from "./auth";
import { apiFetch } from "./Components/ApiCall";
import {
  CDVALET_BASE_URL,
  REACT_APP_API_BASE_URL,
  TRACK_URL,
} from "./utils/constant";

export async function refreshAuth(baseURL = REACT_APP_API_BASE_URL || "") {
  const accessTokenObj = getAccessToken();
  try {
    const res = await apiFetch(
      `/api/v1/auth/get/token/usingRefresh`,
      "GET",
      null,
      {
        Origin: CDVALET_BASE_URL,
        Cookie: `refreshToken=${accessTokenObj?.refreshToken}`,
        refreshToken: accessTokenObj?.refreshToken,
      },
      TRACK_URL,
      2,
      { skipAuth: true, credentials: "include" }
    );
    const tokenObj = { ...accessTokenObj, ...res?.data };
    return tokenObj;
  } catch {
    console.log("error in referesh");
  }
}
